import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function SignatureStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();

  const signatureStatusOptions = [
    { label: 'All Types', value: '' },
    { label: 'Signed', value: 'SIGNED' },
    { label: 'Pending Signature', value: 'PENDING' },
  ];

  return (
    <Dropdown
      options={signatureStatusOptions}
      value={fileManagerFilters?.esignature_status}
      placeholder="All Types"
      className="file-manager-select w-100"
      onChange={(e) => {
        onFilterChange({
          target: { name: 'esignature_status', value: e.value },
          value: e.value,
        });
        setSelectedRows([]);
      }}
      name="esignature_status"
    />
  );
}

export default SignatureStatusFilter;
